import css from "./style.module.scss";

export const minimumScreenWidth = parseInt(css.minimumScreenWidth),
  mobileScreenWidth = parseInt(css.mobileScreenWidth);
